import { useContext } from 'react';
import { AblyContext } from '@poplar/contexts/AblyContext';
export var useAblyContext = function useAblyContext() {
  var ablyContext = useContext(AblyContext);

  if (!ablyContext) {
    throw new Error('AblyContext.Provider not initialized correctly, missing initial state');
  }

  return ablyContext;
};